import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";

import { StorageService } from "../storage.service";
import { Passport } from "./passport.model";
import { environment } from "../../../environments/environment"
import { JwtTokenService } from "./jwt.service";
export let isDebugMode = environment.isDebugMode

@Injectable()
export class AuthService {

    loggedInChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null)
    passportChange: BehaviorSubject<Passport> = new BehaviorSubject<Passport>(null)

    loggedIn: boolean = false
    token: string
    passport: Passport

    constructor(
        private jwt: JwtTokenService
    ) {
        isDebugMode ? console.log(`constructor()`) : undefined
        this.token = this.jwt.getToken()
        this.loggedIn = this.token ? true : false
        this.loggedInChange.next(this.token ? true : false)
    }

}
